import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

// Phones: fixed bar with the current choice and the step's main button.
// Inside an embed it sits at the end of the page instead (the iframe grows
// with its content, so a fixed bar would float over the host page's layout).
export function MobileStepBar({ line1, line2, action, embedded }: {
  line1: string;
  line2?: ReactNode;
  action: ReactNode;
  embedded: boolean;
}) {
  return (
    <div
      className={cn(
        'z-40 flex items-center gap-3 border-t border-line bg-surface px-4 pt-3 shadow-[0_-4px_16px_rgba(15,23,42,0.05)] lg:hidden',
        embedded ? 'sticky bottom-0 mt-6 pb-3' : 'fixed inset-x-0 bottom-0',
      )}
      style={embedded ? undefined : { paddingBottom: 'max(12px, env(safe-area-inset-bottom))' }}
      data-testid="mobile-step-bar"
    >
      <div className="flex min-w-0 flex-1 flex-col gap-0.5">
        <span className="truncate text-[15px] font-semibold tabular-nums text-ink">{line1}</span>
        {line2 && <span className="flex items-center gap-2 truncate text-[13px] text-soft">{line2}</span>}
      </div>
      {action}
    </div>
  );
}
